import { Box } from '@mantine/core';

import { BankCreditResponse, CreditOptionsResponse, CreditResponse } from 'types';

import CreditDetails from './details';
import CreditPaymentStructure from './structure';

interface CreditPaymentProps {
  options: CreditOptionsResponse;
  credit: CreditResponse;
  bankCredit?: BankCreditResponse;
  readOnly?: boolean;
}

const CreditPayment = ({ options, credit, bankCredit, readOnly = false }: CreditPaymentProps) => {
  return (
    <Box p={'lg'}>
      <CreditDetails credit={credit} bankCredit={bankCredit} readOnly={readOnly} />
      <Box mt={64}>
        <CreditPaymentStructure options={options} credit={credit} readOnly={readOnly} />
      </Box>
    </Box>
  );
};

export default CreditPayment;
